<template>
  <el-table-column
    prop="origin_country.name"
    sortable="custom"
    label="Származási ország"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.origin_country">{{ scope.row.origin_country.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'origin_country.name',
  };
</script>
